import React, { FC } from "react";
import { graphql } from "gatsby";

import Header from "src/components/Header";
import { HeadingScope } from "src/components/Heading";
import Services from "src/components/Services";
import Banner from "src/components/Banner";
import ContactsBlock from "src/components/ContactsBlock";
import Footer from "src/components/Footer";

interface HomepageProps {
  data: any;
}
const Homepage: FC<HomepageProps> = ({ data }) => {
  const {
    frontmatter: {
      mainHeading,
      mainImage,
      ctaText,
      ctaUrl,
      servicesHeading,
      whyUsHeading,
      whyUsText,
      whyUsBackground,
      whyUsBtnText,
      whyUsBtnUrl,
      contactsHeading,
      phone,
      email,
      address,
    },
  } = data.content;

  const { services } = data.content.exports;
  return (
    <HeadingScope>
      <Header />
      <Banner
        image={mainImage.childImageSharp.fluid}
        title={mainHeading}
        button={{ title: `${ctaText}`, url: `${ctaUrl}` }}
        main
      />
      <HeadingScope>
        <Services title={servicesHeading} services={services} />
        <Banner
          image={whyUsBackground.childImageSharp.fluid}
          title={whyUsHeading}
          button={{ title: `${whyUsBtnText}`, url: `${whyUsBtnUrl}` }}
          text={whyUsText}
        />
        <ContactsBlock
          title={contactsHeading}
          contacts={{
            phone: `${phone}`,
            email: `${email}`,
            address: `${address}`,
          }}
        />
      </HeadingScope>
      <Footer />
    </HeadingScope>
  );
};

export default Homepage;

export const query = graphql`
  query Homepage {
    content: mdx(slug: { eq: "homepage/" }) {
      slug
      frontmatter {
        mainHeading
        mainImage {
          childImageSharp {
            fluid(maxWidth: 2000) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        ctaText
        ctaUrl
        servicesHeading
        whyUsBackground {
          childImageSharp {
            fluid(maxWidth: 2000) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        whyUsHeading
        whyUsText
        whyUsBtnText
        whyUsBtnUrl
        contactsHeading
        phone
        email
        address
      }
      exports {
        services {
          icon {
            publicURL
          }
          title
          text
        }
      }
    }
  }
`;
